import { render, staticRenderFns } from "./StartStopRecord.vue?vue&type=template&id=299402d5&scoped=true&"
import script from "./StartStopRecord.vue?vue&type=script&lang=js&"
export * from "./StartStopRecord.vue?vue&type=script&lang=js&"
import style0 from "./StartStopRecord.vue?vue&type=style&index=0&id=299402d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299402d5",
  null
  
)

export default component.exports